var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 936.992,
    height: 839.343,
    viewBox: "0 0 936.992 839.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_503",
    "data-name": "Trac\\xE9 503",
    d: "M1270.711,541.827c3.323-298.179-287.569-553.505-607.946-194.05C377.634,670.285,159.293,987.384,543.383,1007.734c417.524-14.827,695.4-137.487,727.328-465.906",
    transform: "translate(-335.428 -170.072)",
    fill: "none",
    stroke: "#702082",
    strokeMiterlimit: 10,
    strokeWidth: 3.36
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrace);
export default __webpack_public_path__ + "static/media/trace.4d82c45479027563a04bf219c92dd24c.svg";
export { ForwardRef as ReactComponent };